import { Box } from "@mui/material";
import { currencyOf } from "utils/util";
import { FlowConsignadoVisualizarAbaIdentificacaoDTO } from "../consignado-visualizar-dialog.model";
import { Item } from "./Item";

export const AbaIdentificacao = (props: { data: FlowConsignadoVisualizarAbaIdentificacaoDTO; }) => {
    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px'
        }}
    >
        <Item label="Ordem" value={props.data.numero} />
        <Item label="Data de emissão" value={props.data.emissao} />
        <Item label="Situacao" value={props.data.situacao} />
        <Item label="Vendedor" value={props.data.vendedor} />
        <Item label="Depósito" value={props.data.deposito} />
        <Item label="Tabela de preço" value={props.data.tabelaPreco} />
        <Item label="Quantidade aberta" value={props.data.quantidadeAberta} />
        <Item label="Quantidade consignada" value={props.data.quantidadeConsignada} />
        <Item label="Quantidade devolvida" value={props.data.quantidadeDevolvida} />
        <Item label="Quantidade vendida" value={props.data.quantidadeVendida} />
        <Item label="Quantidade cancelada" value={props.data.quantidadeCancelada} />
        <Item label="Saldo" value={props.data.saldo} />
        <Item label="Valor aberto" value={currencyOf(props.data.valorAberto)} />
        <Item label="Valor consignado" value={currencyOf(props.data.valorConsignado)} />
    </Box>;
};
